import TREE from '../lib/featureTree.json';
import { CircleHelp, BookOpen, GraduationCap, Rocket, Network, Languages, Ellipsis } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from './ui/dropdown-menu';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';
import { startTourHere } from './TourGuide';

// phone: rarely used header chips move into a "More" popover
export function MoreMenu({ t, on, children }) {
  if (!on) return children;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="chip help-chip" data-testid="header-more-btn" aria-label={t.moreMenu}><Ellipsis size={15} /> <span>{t.moreMenu}</span></button>
      </PopoverTrigger>
      <PopoverContent align="end" className="hdr-more" data-testid="header-more-menu">{children}</PopoverContent>
    </Popover>
  );
}

const LANGS = { de: 'Deutsch', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português', fr: 'Français', sq: 'Shqip' };

export function HelpMenu({ t, manualLabel, onManual, onStartHelp, onTree }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="chip help-chip" data-testid="help-menu-btn" aria-label={t.helpMenu}><CircleHelp size={15} /> <span>{t.helpMenu}</span></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="help-menu" data-testid="help-menu">
        <DropdownMenuItem data-testid="help-btn" onSelect={onManual}><BookOpen size={15} /> {manualLabel}</DropdownMenuItem>
        <DropdownMenuItem data-testid="help-here-main-menu-btn" onSelect={() => startTourHere('main')}><GraduationCap size={15} /> {t.helpHereT || t.helpHere}</DropdownMenuItem>
        <DropdownMenuItem data-testid="starthilfe-btn" onSelect={onStartHelp}><Rocket size={15} /> {t.startHelp}</DropdownMenuItem>
        <DropdownMenuItem data-testid="ftree-btn" onSelect={onTree}><Network size={15} /> {(TREE[localStorage.getItem('baustelle_app_lang')] || TREE.de).ui.title}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function LangSelect({ t, lang, setLang }) {
  return (
    <label className="lang-select" title={t.langLabel}>
      <Languages size={14} />
      <select data-testid="lang-select" aria-label={t.langLabel} value={lang} onChange={(e) => setLang(e.target.value)}>
        {Object.entries(LANGS).map(([k, v]) => <option key={k} value={k} data-testid={`lang-${k}-option`}>{v}</option>)}
      </select>
    </label>
  );
}

// quick header chips: rocket (start help) everywhere, feature tree only on the desktop PC (phones/tablets keep it under "?")
export function QuickHelp({ t, desk, onStartHelp, onTree }) {
  return (
    <>
      <button className="chip help-chip quick-help-chip" data-testid="hdr-starthilfe-btn" onClick={onStartHelp} title={t.startHelp} aria-label={t.startHelp}><Rocket size={15} /> <span>{t.startHelp}</span></button>
      {desk && <button className="chip help-chip quick-help-chip" data-testid="hdr-ftree-btn" onClick={onTree} title={(TREE[localStorage.getItem('baustelle_app_lang')] || TREE.de).ui.title}><Network size={15} /> <span>{(TREE[localStorage.getItem('baustelle_app_lang')] || TREE.de).ui.title}</span></button>}
    </>
  );
}
